module.exports = __webpack_public_path__ + "media/header-kz.8c973fbe.mp4";